import { render, staticRenderFns } from "./TwSpinner.vue?vue&type=template&id=0d9e8a12"
import script from "./TwSpinner.vue?vue&type=script&lang=js"
export * from "./TwSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports